import SystemInfos from './SystemInfo';

export default SystemInfos;
